module.exports = __webpack_public_path__ + "img/step4-07.a3a324c0.jpg";